const common = {
  message: {
    failureMessageUpload: 'Si è verificato un errore, riprovare'
  }
};

export default common;
